import Image from "next/image";
import Container from "../common/Container";

const ServicesList = (properties) => {
  const { headLine, headingButtonColor, techLogoAlt, techLogo, steps } =
    properties.serviceSection;
  return (
    <Container
      large
      className="bg-primary-black pt-32 md:py-20 lg:pt-40 lg:pb-24"
    >
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-6/12">
          <div className="relative md:sticky md:top-28">
            <div className="pb-8 md:pb-4 lg:pb-14 w-1/4">
              <Image
                alt={techLogoAlt}
                src={techLogo}
                title={techLogoAlt}
                width={131}
                height={137}
                objectFit="contain"
              />
            </div>
            <div>
              <h2
                className="text-5xl mb-16 md:mb-0 md:text-4xl lg:text-6xl leading-tight font-medium !bg-clip-text text-transparent lg:w-4/5"
                style={{ background: headingButtonColor }}
              >
                <span>{headLine}</span>
              </h2>
            </div>
          </div>
        </div>
        <div className="w-full md:w-6/12">
          <div>
            {steps.map((values) => (
              <div key={values.title}>
                <div className="flex pb-4 lg:pb-20">
                  <div className="mr-8">
                    <Image
                      alt={values.iconAlt}
                      loading="lazy"
                      src={values.icon}
                      title={values.iconAlt}
                      width={48}
                      height={48}
                      layout="fixed"
                      className="w-8 md:w-12"
                    />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-xl mb-2 lg:text-3xl">
                      <span>{values.title}</span>
                    </h3>
                    <div
                      dangerouslySetInnerHTML={{ __html: values.description }}
                      className="text-justify text-white text-base [&>p]:mb-4"
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ServicesList;
